import { purchaseDropoff } from "@redotech/merchant-sdk/rpc/schema/purchase-dropoff";
import { useRequiredContext } from "@redotech/react-util/context";
import { RedoMerchantRpcClientContext } from "@redotech/redo-merchant-app-common/rpc-client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type * as z from "zod";
import { getLabelRatesQueryKey } from "./use-label-rates";

export type PurchaseDropoffProps = z.infer<typeof purchaseDropoff.input>;
export type PurchaseDropoffResult = z.infer<typeof purchaseDropoff.output>;

export function usePurchaseDropoff() {
  const rpcClient = useRequiredContext(RedoMerchantRpcClientContext);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (props: PurchaseDropoffProps) =>
      rpcClient.purchaseDropoff(props),
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({
        queryKey: getLabelRatesQueryKey(variables.teamId, variables.returnId),
      });
    },
  });
}
